
.container {

  padding: 1em;

  .photos {
    background-color: white;
    //margin: 1em 0;
    padding: 2em;
    border: solid 1px var(--beigedarker);
    border-radius: var(--border-radius);

    &.dropzone {
      //background-color: var(--beige);
      //cursor: pointer;
      border: dashed 1px var(--beigedarker);
    }
  }



  .previewImage {
    width: 142px;
    height: 142px;
  }


}
